import { CREATE_INVENTORY_ITEM, CREATE_INVENTORY_ITEM_ASSIGNMENT, CREATE_INVENTORY_ITEM_CATEGORY, CREATE_INVENTORY_LOCATION, CREATING_INVENTORY_ITEM, CREATING_INVENTORY_ITEM_ASSIGNMENT, CREATING_INVENTORY_ITEM_CATEGORY, CREATING_INVENTORY_LOCATION, DELETE_INVENTORY_ITEM_CATEGORY, DELETE_INVENTORY_LOCATION, DELETING_INVENTORY_ITEM_CATEGORY, DELETING_INVENTORY_LOCATION, GET_INVENTORY_ITEM_ASSIGNMENT, GET_INVENTORY_ITEM_CATEGORIES, GET_INVENTORY_ITEM_VARIANTS, GET_INVENTORY_ITEMS, GET_INVENTORY_LOCATIONS, GETTING_INVENTORY_ITEM_ASSIGNMENT, GETTING_INVENTORY_ITEM_CATEGORIES, GETTING_INVENTORY_ITEM_VARIANTS, GETTING_INVENTORY_ITEMS, GETTING_INVENTORY_LOCATIONS, INVENTORY_ERROR, UPDATE_INVENTORY_ITEM_CATEGORY, UPDATE_INVENTORY_LOCATION, UPDATING_INVENTORY_ITEM_CATEGORY, UPDATING_INVENTORY_LOCATION } from "../types"


const initialState = {
    assignments: [],
    loadingAssignments: false,
    categories: [],
    loadingCategories: false,
    items: [],
    loadingItems: false,
    variants: [],
    loadingVariants: false,
    inventoryError: null,
    creatingItem: false,
    createdItem: null,
    createdVariant: null,
    creatingAssignment: false,
    createdAssignment: null,
    creatingCategory: false,
    createdCategory: null,
    updatingItem: false,
    updatedVariant: null,
    updatingAssignment: false,
    updatedAssignment: null,
    updatingCategory: false,
    updatedCategory: null,
    deletingCategory: false,
    deletedCategory: null,
    locations: [],
    loadingLocations: true,
    creatingLocation: false,
    createdLocation: null,
    updatingLocation: false,
    updatedLocation: null,
    deletingLocation: false,
    deletedLocation: null
    // updatingInstructor: false,
    // updatedInstructor: null,
}

// eslint-disable-next-line import/no-anonymous-default-export
export default function(state = initialState, action){

    switch(action.type){
        case CREATING_INVENTORY_ITEM_CATEGORY:
        return {
            ...state,
            creatingCategory: action.payload,
            // fetchingMembers:false
        }
        case CREATE_INVENTORY_ITEM_CATEGORY:
        return{
            ...state,
            creatingCategory: false,
            inventoryError: false,
            createdCategory: action.payload,
        }
        case UPDATING_INVENTORY_ITEM_CATEGORY:
        return {
            ...state,
            updatingCategory: action.payload,
            // fetchingMembers:false
        }
        case UPDATE_INVENTORY_ITEM_CATEGORY:
        return{
            ...state,
            updatingCategory: false,
            inventoryError: false,
            updatedCategory: action.payload,
        }
        case DELETING_INVENTORY_ITEM_CATEGORY:
        return {
            ...state,
            deletingCategory: action.payload,
            // fetchingMembers:false
        }
        case DELETE_INVENTORY_ITEM_CATEGORY:
        return{
            ...state,
            deletingCategory: false,
            inventoryError: false,
            deletedCategory: action.payload,
        }
        case GETTING_INVENTORY_ITEM_CATEGORIES:
        return {
            ...state,
            loadingCategories: action.payload,
            // fetchingMembers:false
        }
        case GET_INVENTORY_ITEM_CATEGORIES:
        return{
            ...state,
            loadingCategories: false,
            inventoryError: false,
            categories: action.payload,
        }
        case CREATING_INVENTORY_ITEM_ASSIGNMENT:
        return {
            ...state,
            creatingAssignment: action.payload,
            // fetchingMembers:false
        }
        case CREATE_INVENTORY_ITEM_ASSIGNMENT:
        return{
            ...state,
            creatingAssignment: false,
            inventoryError: false,
            createdAssignment: action.payload,
        }
        case GETTING_INVENTORY_ITEM_ASSIGNMENT:
        return {
            ...state,
            loadingAssignments: action.payload,
            // fetchingMembers:false
        }
        case GET_INVENTORY_ITEM_ASSIGNMENT:
        return{
            ...state,
            loadingAssignments: false,
            inventoryError: false,
            assignments: action.payload,
        }
        case GETTING_INVENTORY_ITEMS:
        return {
            ...state,
            loadingItems: action.payload,
            // fetchingMembers:false
        }
        case GET_INVENTORY_ITEMS:
        return{
            ...state,
            loadingItems: false,
            inventoryError: false,
            items: action.payload,
        }
        case GETTING_INVENTORY_ITEM_VARIANTS:
        return {
            ...state,
            loadingVariants: action.payload,
            // fetchingMembers:false
        }
        case GET_INVENTORY_ITEM_VARIANTS:
        return{
            ...state,
            loadingVariants: false,
            inventoryError: false,
            variants: action.payload,
        }
        case CREATING_INVENTORY_ITEM:
        return {
            ...state,
            creatingItem: action.payload,
            // fetchingMembers:false
        }
        case CREATE_INVENTORY_ITEM:
        return{
            ...state,
            creatingItem:false,
            inventoryError: false,
            createdItem: action.payload,
        }
        case CREATING_INVENTORY_LOCATION:
        return {
            ...state,
            creatingLocation: action.payload
        }
        case CREATE_INVENTORY_LOCATION:
        return {
            ...state,
            creatingLocation: false,
            createdLocation: action.payload
        }
        case GETTING_INVENTORY_LOCATIONS:
        return {
            ...state,
            loadingLocations: action.payload
        }
        case GET_INVENTORY_LOCATIONS:
        return {
            ...state,
            loadingLocations: false,
            locations: action.payload
        }
        case UPDATING_INVENTORY_LOCATION:
        return {
            ...state,
            updatingLocation: action.payload
        }
        case UPDATE_INVENTORY_LOCATION:
        return {
            ...state,
            updatingLocation: false,
            updatedLocation: action.payload
        }
        case DELETING_INVENTORY_LOCATION:
        return {
            ...state,
            deletingLocation: action.payload
        }
        case DELETE_INVENTORY_LOCATION:
        return {
            ...state,
            deletingLocation: false,
            deletedLocation: action.payload
        }
        case INVENTORY_ERROR:
        return{
            ...state,
            loadingCategories:false,
            creatingCategory:false,
            updatingCategory:false,
            creatingItem: false,
            creatingAssignment: false,
            loadingAssignments: false,
            loadingVariants: false,
            loadingLocations: false,
            deletingLocation: false,
            updatingLocation: false,
            creatingLocation: false,
            inventoryError: action.payload 
        }
        default: return state
    }

}